<template>
  <div />
</template>

<script>
export default {
  name: 'CatalogView',
  mounted() {
    this.$router.push({ path: '/catalog/categories' });
  }
};
</script>
